/* eslint-disable @typescript-eslint/naming-convention */
import React, { FunctionComponent, useState, useEffect } from 'react';
import { LabelPosition, StandardSwitch } from '@brandfolder/react';
import { AssetsResponse } from '@api/v4/assets/assetTypes';
import { bulkRefreshSections } from '@helpers/show_page_helpers';

import { PrimaryButton } from '@components/library/button';
import { StandardDialog } from '@components/library/dialog';
import { useFetch } from '@api/ApiHelper';

import classes from './styles/bulk-view-only-dialog.module.scss';

interface BulkViewOnlyDialogProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  assetKeys: string[];
}

const initialViewOnly = false;

export const BulkViewOnlyDialog: FunctionComponent<BulkViewOnlyDialogProps> = ({ 
  assetKeys,
  open, 
  setOpen,
}) => {

  const [viewOnly, setViewOnly] = useState(initialViewOnly);

  const updateViewOnlyAssets = useFetch<AssetsResponse>({
    body: {
      data: {
        asset_keys: assetKeys, 
        view_only: viewOnly,
      }
    },
    fetchOnMount: false,
    method: 'PUT',
    url: '/api/v4/bulk_actions/assets/view_only'
  });

  useEffect(() => {
    if (updateViewOnlyAssets.response) {
      bulkRefreshSections(assetKeys);
      setViewOnly(initialViewOnly);
      setOpen(false);
    }
   
  }, [updateViewOnlyAssets.response]);

  useEffect(() => {
    if (updateViewOnlyAssets.error) {
      Notify.create({
        title: bfTranslate('Something went wrong. Try again soon!'),
        type: 'error'
      });
    }
  }, [updateViewOnlyAssets.response]);
  
  return (
      <StandardDialog
        id="bulk-view-only-dialog"
        open={open}
        setOpen={setOpen}
        showFooter={false}
        title={bfTranslate('View Only mode')}
        titleIcon="bff-show"
        width={360}
      >
        <div>
          <p className={classes.p}>
            {bfTranslate('Disable downloads to guests and public users. Administrators will be notified if a user requests a download.')}
          </p>
          <StandardSwitch
            className={classes.switch}
            id="view-only-toggle"
            isChecked={viewOnly}
            labelPosition={LabelPosition.Right}
            onChange={(): void => {
              setViewOnly((prevState) => (!prevState));
            }}
          >
            {bfTranslate('Disable downloads (view only mode)')}
          </StandardSwitch>
          <div className={classes.buttonGroup}>
            <PrimaryButton 
              className={classes.button}
              isLoading={updateViewOnlyAssets.loading}
              onClick={(): void => { 
                updateViewOnlyAssets.fetch(); 
              }}
            >
              {bfTranslate('Save Changes')}
            </PrimaryButton>
          </div>
        </div>
      </StandardDialog>  
  );
};
